import { render, staticRenderFns } from "./BadContact.vue?vue&type=template&id=0f54f510&scoped=true&"
import script from "./BadContact.vue?vue&type=script&lang=js&"
export * from "./BadContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f54f510",
  null
  
)

export default component.exports